// extracted by mini-css-extract-plugin
module.exports = {"search-tags__list":"SearchTags_search-tags__list__1qByx"};